export const cardContent = [
  {
    icon: "https://img.icons8.com/color/344/pinguin.png",
    title: "Simple Queues",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page at its layout.",
  },
  {
    icon: "https://img.icons8.com/color/344/pinguin.png",
    title: "Simple Queues",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page at its layout.",
  },
  {
    icon: "https://img.icons8.com/color/344/pinguin.png",
    title: "Simple Queues",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page at its layout.",
  },
  {
    icon: "https://img.icons8.com/color/344/pinguin.png",
    title: "Simple Queues",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page at its layout.",
  },
  {
    icon: "https://img.icons8.com/color/344/pinguin.png",
    title: "Simple Queues",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page at its layout.",
  },
  {
    icon: "https://img.icons8.com/color/344/pinguin.png",
    title: "Simple Queues",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page at its layout.",
  },
];

export const pricingData = [
  {
    title: "Hobby",
    details: "All the basics for starting a new business",
    price: "$12",
    buttonText: "Buy Hobby",
    includeInCourse: [
      "Cras justo odio.",
      "Dapibus ac facilisis in.",
      "Morbi leo risus.",
      "Potenti felis, in cras ligula.",
    ],
  },
  {
    title: "Hobby",
    details: "All the basics for starting a new business",
    price: "$12",
    buttonText: "Buy Hobby",
    includeInCourse: [
      "Cras justo odio.",
      "Dapibus ac facilisis in.",
      "Morbi leo risus.",
      "Potenti felis, in cras ligula.",
    ],
  },
  {
    title: "Hobby",
    details: "All the basics for starting a new business",
    price: "$12",
    buttonText: "Buy Hobby",
    includeInCourse: [
      "Cras justo odio.",
      "Dapibus ac facilisis in.",
      "Morbi leo risus.",
      "Potenti felis, in cras ligula.",
    ],
  },
  {
    title: "Hobby",
    details: "All the basics for starting a new business",
    price: "$12",
    buttonText: "Buy Hobby",
    includeInCourse: [
      "Cras justo odio.",
      "Dapibus ac facilisis in.",
      "Morbi leo risus.",
      "Potenti felis, in cras ligula.",
    ],
  },
];

export const navlinks = [
  "Home",
  "Features",
  "Overview",
  "Pricing",
  "Team",
  "Blog",
  "Contact",
];


